import React from "react";
import Slider from "react-slick";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const guestItems = [
  {
    title: "C. Sylendra Babu",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147032/C._Sylendra_Babu_I.P.S_gb7hdr.png",
    badge: "I.P.S (Former Director General Of Police)",
  },
  {
    title: "Dr. Sheribha",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147020/Dr.SHERIBHA_M.B.B.S._M.D._lyhwmq.png",
    badge: "M.B.B.S., M.D.",
  },
  {
    title: "Thiru. S. Paneerselvam",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147021/11_ijrqkb.png",
    badge: "Indian Police Service",
  },
  {
    title: "Mrs. P. Sheela Florance",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147021/Mrs.P.SHEELA_FLORANCE_d6xugv.png",
    badge: "District Educational Officer",
  },
  {
    title: "Mrs. P. Shanthi Devi",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147020/Mrs.P.SHANTHI_DEVI_beykuy.png",
    badge: "Inspector Of Police",
  },
  {
    title: "Thiru S. Rameshbabu",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147021/Thiru_S.RAMESHBABU_zuibpa.png",
    badge: "T.P.S",
  },
  {
    title: "Dr. K. Mohan",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/v1765147102/Dr.K.MOHAN_yx0jbt.png",
    badge: "Deputy Registrar - TNTEU",
  },
  {
    title: "Dr. M. Selvaraj",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147020/Dr.M.SELVARAJ_mdz9ob.png",
    badge: "Tamilnadu Information Commissioner",
  },
  {
    title: "Dr. A. Manivannan",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147070/Dr.A.MANIVANNAN_nwixlh.png",
    badge: "Deputy Commissioner Of Police",
  },
  {
    title: "Mr. G. Parthiban",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147020/Mr.G.PARTHIBAN_mfpfwe.png",
    badge: "Asst. Commissioner Of Police",
  },
  {
    title: "Thiru. K. Boopathiraj",
    image: "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto,w_400/v1765147020/THIRU.K.BOOPATHIRAJ_f24ne3.png",
    badge: "Inspector Of Police",
  },
];


const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute top-1/2 right-[-40px] transform -translate-y-1/2 z-10 bg-black text-white hover:bg-gray-800 w-10 h-10 rounded-full flex items-center justify-center shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
    aria-label="Next slide"
  >
    <ChevronRightIcon className="w-5 h-5" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute top-1/2 left-[-40px] transform -translate-y-1/2 z-10 bg-black text-white hover:bg-gray-800 w-10 h-10 rounded-full flex items-center justify-center shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
    aria-label="Previous slide"
  >
    <ChevronLeftIcon className="w-5 h-5" />
  </button>
);

const Guest = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    cssEase: "ease-in-out",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4, arrows: true } },
      { breakpoint: 1024, settings: { slidesToShow: 3, arrows: true } },
      { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="relative w-screen left-1/2 right-1/2 mx-[-50vw] overflow-hidden -mt-12 md:-mt-16 lg:-mt-20 -mb-12 md:-mb-16 lg:-mb-20 py-16 md:py-20 lg:py-24">
      {/* Full-width blurred background */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75"
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/ddvpczzng/image/upload/v1757494396/Page_No.1_ljhrsn_wne4rj.jpg')",
        }}
      ></div>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-24">
          <h2 className="text-4xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Our <span className="text-amber-600">Guests</span>
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-2xl font-serif text-white mt-3">
            The Symbols of Inspiration!
          </h3>
        </div>

        <div className="relative">
          <Slider {...settings}>
            {guestItems.map((item, index) => (
              <div key={index} className="px-2 focus:outline-none">
                <div className="group bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200 mx-auto w-full max-w-[240px] h-[340px] flex flex-col transition-all duration-300 hover:shadow-lg">
                  {/* Image container */}
                  <div className="w-full h-[255px] flex-shrink-0 relative overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                      width={240}
                      height={255}
                      decoding="async"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://via.placeholder.com/240x255?text=Guest";
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>

                  {/* Text container with simple badge */}
                  <div className="flex-1 min-h-[80px] max-h-[80px] px-3 py-2 flex flex-col justify-between bg-gradient-to-b from-white to-gray-50">
                    {/* Title */}
                    <div className="h-[48px] flex items-center justify-center overflow-hidden">
                      <h3 className="text-xs sm:text-sm font-semibold text-gray-900 text-center leading-tight group-hover:text-amber-700 transition-colors duration-300 line-clamp-2 px-1">
                        {item.title}
                      </h3>
                    </div>

                    {/* Simple badge without color */}
                    <div className="flex justify-center">
                      <span className="inline-block text-[10px] sm:text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded-full font-medium whitespace-nowrap border border-gray-200">
                        {item.badge}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <style>{`
        .slick-arrow { width: 40px; height: 40px; display: flex !important; align-items: center; justify-content: center; border-radius: 50%; box-shadow: 0 4px 6px rgba(0,0,0,0.1); transition: all 0.3s ease; }
        .slick-arrow:hover { transform: scale(1.05); }
        .slick-arrow::before { display: none; }
        .slick-next { right: -15px; }
        .slick-prev { left: -15px; }
        
        .slick-slide > div > div {
          height: 340px;
        }
        
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .slick-slide > div > div:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }
      `}</style>
    </section>
  );
};

export default Guest;
